
// 监听enter键并触发对应监听函数，同时支持click事件触发
// 注册一个全局自定义指令 `v-debounceClick`
export default {
  inserted: function(el, binding, vnode) {
    // // 解除绑定标识
    // console.log('监听enter键并触发对应监听函数，同时支持click事件触发6666666666666', el, binding, document);
    el.addEventListener('click', () => {
      // console.log('监听点击事件：', event, el.style, '我是所有用的dom节点：');
      // 禁用使用这个指令的DOM结构点击事件
      el.style.pointerEvents = 'none';
      setTimeout(() => {
          // 启动使用这个指令的DOM结构点击事件
          el.style.pointerEvents = 'auto';
      }, binding.value || 500);
    });

  },
  unbind: function(el, binding) {
    // el.removeEventListener('keypress', binding.value);
  }
};
